import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseService } from 'src/app/modals/response/response-service.model';

@Injectable({
  providedIn: 'root'
})

export class CrudServerService {
    
  constructor(private http: HttpClient) { }

  fetchTableData(url: any, service: any): Observable<ResponseService> {

    let params = new HttpParams()
            .set('page', service.page?.toString())
            .set('limit', service.limit?.toString())
            .set('sortColumn', service.sortColumn)
            .set('sortDirection', service.sortDirection);

    Object.entries(service.filters).forEach(([key, value]) => {
        if (value) {
            params = params.set(key, value.toString());
        }
    });

    return this.http.get<ResponseService>(url, { params });
  }

  fetchData(url: any): Observable<ResponseService> {
      return this.http.get<ResponseService>(url);
  }

  addData(url: any, newData: any): Observable<ResponseService> {
      return this.http.post<ResponseService>(url, newData);
  }

  updateData(url: any, updatedData: any): Observable<ResponseService> {
      return this.http.put<ResponseService>(url, updatedData);
  }

  updateDataPost(url: any, updatedData: any): Observable<ResponseService> {
      return this.http.post<ResponseService>(url, updatedData);
  }

  deleteData(url: any): Observable<ResponseService> {
      return this.http.delete<ResponseService>(url);
  }
}